type Envelope<T> = { data: T; meta: { requestId: string } };
type ErrorEnvelope = { error: { code: string; message: string; fields?: unknown }; meta?: { requestId: string } };

export class ApiError extends Error {
  code: string;
  status: number;
  fields?: unknown;
  constructor(status: number, payload: ErrorEnvelope) {
    super(payload.error.message);
    this.code = payload.error.code;
    this.status = status;
    this.fields = payload.error.fields;
  }
}

function readCookie(name: string) {
  return document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith(`${name}=`))?.slice(name.length + 1);
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = init.method?.toUpperCase() ?? "GET";
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (!["GET", "HEAD"].includes(method)) {
    const csrf = readCookie("ubp_csrf");
    if (csrf) headers.set("X-CSRF-Token", decodeURIComponent(csrf));
  }
  const response = await fetch(`/api/v1${path}`, { ...init, headers, credentials: "include" });
  const payload = await response.json() as Envelope<T> | ErrorEnvelope;
  if (!response.ok) throw new ApiError(response.status, payload as ErrorEnvelope);
  return (payload as Envelope<T>).data;
}

export function json(method: "POST" | "PATCH" | "DELETE", body?: unknown): RequestInit {
  return { method, ...(body === undefined ? {} : { body: JSON.stringify(body) }) };
}
